var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5V11.5",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99932 11.4999L13.8293 13.4693C13.9253 13.5044 14.0298 13.5093 14.1287 13.4832C14.2276 13.4572 14.3161 13.4014 14.3823 13.3235C14.4485 13.2456 14.4892 13.1492 14.4989 13.0475C14.5087 12.9457 14.487 12.8434 14.4368 12.7543L8.43119 2.25428C8.38795 2.17613 8.32457 2.11098 8.24763 2.06562C8.17069 2.02026 8.08301 1.99634 7.99369 1.99634C7.90438 1.99634 7.81669 2.02026 7.73976 2.06562C7.66282 2.11098 7.59943 2.17613 7.55619 2.25428L1.56557 12.7543C1.5159 12.8431 1.49451 12.9449 1.50425 13.0462C1.51399 13.1475 1.55441 13.2434 1.6201 13.3211C1.68578 13.3988 1.77362 13.4546 1.87187 13.4811C1.97012 13.5076 2.0741 13.5035 2.16994 13.4693L7.99932 11.4999Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_1003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7420e31ebeb4396caf1e72893d6a8909.svg";
export { ForwardRef as ReactComponent };